import * as moment from 'moment-timezone';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Dialog } from '../ui/dialog/dialog';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { DossierFilter } from './dossier.service';

/**
 * Dossier filter dialog
 */
@Component({
  templateUrl: './dossier-filter-dialog.component.html',
  host: {'(window:keydown)': 'hotkeys($event)'},
  styles: [
    `.dialog-container {
      display: block;
      position: fixed;
      z-index: 300;
      width: 100%;
      left: 0;
    }`
  ],
  animations: [
    trigger(
      'openState',
      [
        state(
          'open',
          style({
            top: '0px'
          })
        ),
        state(
          'closed',
          style({
            top: '-306px'
          })
        ),
        transition('closed => open', animate('400ms ease-out')),
        transition('open => closed', animate('400ms ease-in')),
      ]
    ),
  ]
})
export class DossierFilterDialogComponent implements Dialog, OnInit {
  state = 'closed';

  filter: DossierFilter

  lastSearch: string
  searchTimer: any

  @ViewChild('searchInput')
  searchInput: ElementRef

  orderBy = 'NAME/ASC'
  updateDate = 'ALL_TIME'

  ORDER_BY_OPTIONS = [
    {
      id: 'NAME/DESC',
      text: 'Nom ↓'
    },
    {
      id: 'NAME/ASC',
      text: 'Nom ↑'
    }
  ];

  UPDATE_DATE_OPTIONS = [
    {
      id: 'ALL_TIME',
      text: 'Tout le temps'
    },
    {
      id: 'LAST_30_DAYS',
      text: 'Les 30 derniers jours'
    }
  ]; 
  
  onClose: () => void
  onApply: (filter: DossierFilter) => void

  ngOnInit() {
    this.lastSearch = this.filter.search;

    this.orderBy = this.filter.order_by + '/' + this.filter.order_direction;

    if(this.filter.start_date !== '0') {
      this.updateDate = 'LAST_30_DAYS';
    }
    else {
      this.updateDate = 'ALL_TIME';
    }

    // Focus search input
    this.searchInput.nativeElement.focus();
  }

  close() {
    this.onClose();
  }

  apply() {
    let [order_by, order_by_direction] = this.orderBy.split('/');

    if(order_by === 'NAME') {
      this.filter.order_by = order_by;
    }

    if(order_by_direction === 'ASC' || order_by_direction === 'DESC') {
      this.filter.order_direction = order_by_direction;
    }

    if(this.updateDate === 'ALL_TIME') {
      this.filter.start_date = '0';
      this.filter.end_date = '0';
    }
    else if(this.updateDate === 'LAST_30_DAYS') {
      this.filter.start_date = (moment.utc().add(-30, 'd').toDate().getTime()).toString();
      this.filter.end_date = '0';
    }

    this.onApply(this.filter);
  }

  hotkeys(event: KeyboardEvent){

    switch(event.keyCode) {
      // Escape key
      case 27:
        this.close();
        break;
      // Enter key
      case 13:
        this.apply();
        this.close();
        break;
    }
  }

  searchKeyup(event: KeyboardEvent) {
    if(this.lastSearch !== this.filter.search) {
      this.lastSearch = this.filter.search;

      if(this.searchTimer) {
        window.clearTimeout(this.searchTimer);
      }

      this.searchTimer = window.setTimeout(() => {
        this.apply();
      }, 500);
    }
  }
}

